"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppleTargetingKeywordResponseSchema = exports.UpdateAppleTargetingKeywordBodySchema = exports.CreateAppleTargetingKeywordBodySchema = exports.UpdateRegionalKeywordAssignmentsResponseSchema = exports.ListRegionalKeywordAssignmentsResponseSchema = exports.GetRegionalKeywordAssignmentQuerySchema = exports.RegionalKeywordAssignmentQuerySchema = exports.UpdateRegionalKeywordAssignmentBodySchema = exports.GetRegionalKeywordAssignmentSchema = exports.RegionalKeywordAssignmentSchema = exports.ListAppleSeedKeywordResponseSchema = exports.GetAppleSeedKeywordQuerySchema = exports.UpdateAppleSeedKeywordResponseSchema = exports.CreateAppleSeedKeywordResponseSchema = exports.GetAppleSeedKeywordResponseSchema = exports.AppleSeedKeywordResponseSchema = exports.UpdateAppleSeedKeywordBodySchema = exports.CreateAppleSeedKeywordBodySchema = exports.UpdateAppleNegativeKeywordResponseSchema = exports.CreateAppleNegativeKeywordResponseSchema = exports.ListAppleNegativeKeywordResponseSchema = exports.GetAppleNegativeKeywordQuerySchema = exports.GetAppleNegativeKeywordResponseSchema = exports.AppleNegativeKeywordResponseSchema = exports.UpdateAppleNegativeKeywordBodySchema = exports.CreateAppleNegativeKeywordBodySchema = exports.ListAppleTagsResponseSchema = exports.ListAppleTagsQuerySchema = exports.AppleTagResponseSchema = exports.UpdateAppleTagKeywordsBodySchema = exports.UpdateAppleTagRegionsBodySchema = exports.UpdateAppleSearchResultsRegionBodySchema = exports.CreateAppleSearchResultsRegionBodySchema = exports.ListAppleSearchResultsRegionResponseSchema = exports.ListAppleSearchResultsRegionQuerySchema = exports.UpdateAppleSearchResultsRegionResponseSchema = exports.CreateAppleSearchResultsRegionResponseSchema = exports.GetAppleSearchResultsRegionResponseSchema = exports.AppleSearchResultsRegionResponseSchema = exports.AppleSearchResultsRegionFields = exports.AppleRegionCpdDetailsSchema = exports.ListAppleSearchResultsChannelResponseSchema = exports.ListAppleSearchResultsChannelsQuerySchema = exports.UpdateAppleSearchResultsChannelResponseSchema = exports.GetAppleSearchResultsChannelResponseSchema = exports.CreateAppleSearchResultsChannelResponseSchema = exports.AppleSearchResultsChannelResponseSchema = exports.AppleSearchResultsChannelFields = exports.UpdateAppleSearchResultsChannelBodySchema = exports.CreateAppleSearchResultsChannelBodySchema = void 0;
exports.AsrTargetingKeywordHistoryQuerySchema = exports.AsrTargetingKeywordHistoryResponseSchema = exports.UpdateAsrAppleCampaignNamesResponseSchema = exports.UpdateAsrAppleCampaignNamesBodySchema = exports.ListAsrAppleCampaignNamesQuerySchema = exports.ListAsrAppleCampaignNamesResponseSchema = exports.ListAppleTargetingKeywordResponseSchema = exports.ListAppleTargetingKeywordQuerySchema = exports.UpdateAppleTargetingKeywordResponseSchema = exports.CreateAppleTargetingKeywordResponseSchema = exports.GetAppleTargetingKeywordResponseSchema = exports.GetAppleTargetingKeywordQuerySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const apple_proxy_web_1 = require("../../apple-proxy-web");
const common_1 = require("./common");
/**
 * Channel API Types
 */
exports.CreateAppleSearchResultsChannelBodySchema = (0, core_1.StrictObject)({
    ...common_1.CreateAppleChannelFields,
    keywordBidStrategy: ruby_1.KeywordBidStrategySchema,
    structure: ruby_1.ChannelStructureSchema,
    purposes: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.PurposeSchema)),
    targetEvent: (0, core_1.OptionalNullable)(ruby_1.AttributionEventNameSchema),
    targetEventGoal: (0, core_1.OptionalNullable)(core_1.MoneySchema),
    targetRoas: (0, core_1.OptionalNullable)(typebox_1.Type.Boolean()),
    targetRoasGoal: (0, core_1.OptionalNullable)(core_1.UnderOrOverPercentageSchema),
    targetRoasTimeRange: (0, core_1.OptionalNullable)(typebox_1.Type.Number()),
    keywordSources: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.KeywordSourceSchema)),
    bidUpdateTimes: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.Number({ minimum: 0, maximum: 23 }), { maxItems: 12 })),
});
exports.UpdateAppleSearchResultsChannelBodySchema = (0, core_1.StrictObject)({
    ...common_1.UpdateAppleChannelFields,
    keywordBidStrategy: typebox_1.Type.Optional(ruby_1.KeywordBidStrategySchema),
    purposes: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.PurposeSchema)),
    targetEvent: (0, core_1.OptionalNullable)(ruby_1.AttributionEventNameSchema),
    targetEventGoal: (0, core_1.OptionalNullable)(core_1.MoneySchema),
    targetRoas: (0, core_1.OptionalNullable)(typebox_1.Type.Boolean()),
    targetRoasGoal: (0, core_1.OptionalNullable)(core_1.UnderOrOverPercentageSchema),
    targetRoasTimeRange: (0, core_1.OptionalNullable)(typebox_1.Type.Number()),
    keywordSources: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.KeywordSourceSchema)),
    bidUpdateTimes: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.Number({ minimum: 0, maximum: 23 }), { maxItems: 12 })),
});
exports.AppleSearchResultsChannelFields = {
    ...common_1.AppleChannelIdFields,
    ...core_1.DateMetaFields,
    ...common_1.CreateAppleChannelFields,
    structure: ruby_1.ChannelStructureSchema,
    cpdGoal: core_1.MoneySchema,
    keywordBidStrategy: ruby_1.KeywordBidStrategySchema,
    purposes: typebox_1.Type.Array(ruby_1.PurposeSchema),
    targetEvent: typebox_1.Type.Optional(ruby_1.AttributionEventNameSchema),
    targetEventGoal: typebox_1.Type.Optional(core_1.MoneySchema),
    targetRoas: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    targetRoasGoal: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
    targetRoasTimeRange: typebox_1.Type.Optional(typebox_1.Type.Number()),
    keywordSources: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.KeywordSourceSchema)),
    bidUpdateTimes: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.Number({ minimum: 0, maximum: 23 }), { maxItems: 12 })),
};
exports.AppleSearchResultsChannelResponseSchema = (0, core_1.StrictObject)(exports.AppleSearchResultsChannelFields);
exports.CreateAppleSearchResultsChannelResponseSchema = exports.AppleSearchResultsChannelResponseSchema;
exports.GetAppleSearchResultsChannelResponseSchema = exports.AppleSearchResultsChannelResponseSchema;
exports.UpdateAppleSearchResultsChannelResponseSchema = exports.AppleSearchResultsChannelResponseSchema;
exports.ListAppleSearchResultsChannelsQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    campaignId: typebox_1.Type.Optional(core_1.IdSchema),
    status: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AppleChannelStatusSchema)),
});
exports.ListAppleSearchResultsChannelResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AppleSearchResultsChannelResponseSchema);
/**
 * Channel region API Types
 */
exports.AppleRegionCpdDetailsSchema = (0, core_1.StrictObject)({
    hourlyBoost: typebox_1.Type.Optional((0, core_1.StrictObject)({
        0: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
        1: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
        2: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
        3: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
        4: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
        5: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
        6: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
        7: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
        8: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
        9: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
        10: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
        11: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
        12: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
        13: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
        14: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
        15: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
        16: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
        17: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
        18: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
        19: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
        20: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
        21: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
        22: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
        23: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
    })),
});
exports.AppleSearchResultsRegionFields = {
    ...core_1.ModelMetaFields,
    budgetWeighting: core_1.WeightingSchema,
    defaultBidAmount: typebox_1.Type.Optional(core_1.MoneySchema),
    status: ruby_1.AppleChannelRegionStatusSchema,
    country: core_1.CountrySchema,
    purpose: ruby_1.PurposeSchema,
    cpdGoal: typebox_1.Type.Optional(core_1.MoneySchema),
    cpdDetails: typebox_1.Type.Optional(exports.AppleRegionCpdDetailsSchema),
    targetEvent: typebox_1.Type.Optional(ruby_1.AttributionEventNameSchema),
    targetEventGoal: typebox_1.Type.Optional(core_1.MoneySchema),
    targetRoas: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    targetRoasGoal: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
    targetRoasTimeRange: typebox_1.Type.Optional(typebox_1.Type.Number()),
    apple: typebox_1.Type.Optional((0, core_1.StrictObject)({
        orgRef: ruby_1.AppleProxyOrgRefSchema,
        campaignRef: ruby_1.AppleProxyRefSchema,
    })),
};
exports.AppleSearchResultsRegionResponseSchema = (0, core_1.StrictObject)(exports.AppleSearchResultsRegionFields);
exports.GetAppleSearchResultsRegionResponseSchema = exports.AppleSearchResultsRegionResponseSchema;
exports.CreateAppleSearchResultsRegionResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AppleSearchResultsRegionResponseSchema);
exports.UpdateAppleSearchResultsRegionResponseSchema = exports.AppleSearchResultsRegionResponseSchema;
exports.ListAppleSearchResultsRegionQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({});
exports.ListAppleSearchResultsRegionResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AppleSearchResultsRegionResponseSchema);
exports.CreateAppleSearchResultsRegionBodySchema = (0, core_1.StrictObject)({
    ...common_1.CreateAppleRegionCommonFields,
    country: core_1.CountrySchema,
    cpdDetails: typebox_1.Type.Optional(exports.AppleRegionCpdDetailsSchema),
    targetEvent: typebox_1.Type.Optional(ruby_1.AttributionEventNameSchema),
    targetEventGoal: typebox_1.Type.Optional(core_1.MoneySchema),
    targetRoas: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    targetRoasGoal: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
    targetRoasTimeRange: typebox_1.Type.Optional(typebox_1.Type.Number()),
});
exports.UpdateAppleSearchResultsRegionBodySchema = (0, core_1.StrictObject)({
    ...common_1.UpdateAppleRegionCommonFields,
    cpdDetails: typebox_1.Type.Optional(exports.AppleRegionCpdDetailsSchema),
    targetEvent: (0, core_1.OptionalNullable)(ruby_1.AttributionEventNameSchema),
    targetEventGoal: (0, core_1.OptionalNullable)(core_1.MoneySchema),
    targetRoas: (0, core_1.OptionalNullable)(typebox_1.Type.Boolean()),
    targetRoasGoal: (0, core_1.OptionalNullable)(core_1.UnderOrOverPercentageSchema),
    targetRoasTimeRange: (0, core_1.OptionalNullable)(typebox_1.Type.Number()),
});
// Tags - combined regional and targeting keywords
exports.UpdateAppleTagRegionsBodySchema = (0, core_1.StrictObject)({
    tag: ruby_1.TagSchema,
    purpose: ruby_1.PurposeSchema,
    country: core_1.CountrySchema,
    status: typebox_1.Type.Optional(ruby_1.AppleChannelKeywordStatusSchema),
    forceBidAmount: (0, core_1.OptionalNullable)(core_1.MoneySchema),
    minBidAmount: typebox_1.Type.Optional(core_1.MoneySchema),
    maxBidAmount: typebox_1.Type.Optional(core_1.MoneySchema),
});
exports.UpdateAppleTagKeywordsBodySchema = (0, core_1.StrictObject)({
    tag: ruby_1.TagSchema,
    status: typebox_1.Type.Optional(ruby_1.AppleChannelKeywordStatusSchema),
    forceBidAmount: (0, core_1.OptionalNullable)(core_1.MoneySchema),
    match: typebox_1.Type.Optional(ruby_1.KeywordMatchTypeSchema),
    minBidAmount: typebox_1.Type.Optional(core_1.MoneySchema),
    maxBidAmount: typebox_1.Type.Optional(core_1.MoneySchema),
});
exports.AppleTagResponseSchema = (0, core_1.StrictObject)({
    tag: ruby_1.TagSchema,
});
exports.ListAppleTagsQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({});
exports.ListAppleTagsResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AppleTagResponseSchema);
// Negative keywords
exports.CreateAppleNegativeKeywordBodySchema = (0, core_1.StrictObject)({
    match: ruby_1.KeywordMatchTypeSchema,
    text: ruby_1.KeywordSchema,
    status: ruby_1.AppleChannelKeywordStatusSchema,
});
exports.UpdateAppleNegativeKeywordBodySchema = (0, core_1.StrictObject)({
    status: ruby_1.AppleChannelKeywordStatusSchema,
});
exports.AppleNegativeKeywordResponseSchema = (0, core_1.StrictObject)({
    ...core_1.ModelMetaFields,
    match: ruby_1.KeywordMatchTypeSchema,
    text: ruby_1.KeywordSchema,
    status: ruby_1.AppleChannelKeywordStatusSchema,
    apple: typebox_1.Type.Optional(typebox_1.Type.Array((0, core_1.StrictObject)({
        campaignRef: ruby_1.AppleProxyRefSchema,
        keywordRef: ruby_1.AppleProxyRefSchema,
    }))),
});
exports.GetAppleNegativeKeywordResponseSchema = exports.AppleNegativeKeywordResponseSchema;
exports.GetAppleNegativeKeywordQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({});
exports.ListAppleNegativeKeywordResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AppleNegativeKeywordResponseSchema);
exports.CreateAppleNegativeKeywordResponseSchema = exports.AppleNegativeKeywordResponseSchema;
exports.UpdateAppleNegativeKeywordResponseSchema = exports.AppleNegativeKeywordResponseSchema;
// Seed keywords
exports.CreateAppleSeedKeywordBodySchema = (0, core_1.StrictObject)({
    match: ruby_1.KeywordMatchTypeSchema,
    text: ruby_1.KeywordSchema,
    status: ruby_1.AppleChannelKeywordStatusSchema,
});
exports.UpdateAppleSeedKeywordBodySchema = (0, core_1.StrictObject)({
    status: ruby_1.AppleChannelKeywordStatusSchema,
});
exports.AppleSeedKeywordResponseSchema = (0, core_1.StrictObject)({
    ...core_1.ModelMetaFields,
    match: ruby_1.KeywordMatchTypeSchema,
    text: ruby_1.KeywordSchema,
    status: ruby_1.AppleChannelKeywordStatusSchema,
});
exports.GetAppleSeedKeywordResponseSchema = exports.AppleSeedKeywordResponseSchema;
exports.CreateAppleSeedKeywordResponseSchema = exports.AppleSeedKeywordResponseSchema;
exports.UpdateAppleSeedKeywordResponseSchema = exports.AppleSeedKeywordResponseSchema;
exports.GetAppleSeedKeywordQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({});
exports.ListAppleSeedKeywordResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AppleSeedKeywordResponseSchema);
// Assignments of keyword to region
exports.RegionalKeywordAssignmentSchema = (0, core_1.StrictObject)({
    keywordId: core_1.IdSchema,
    regionId: core_1.IdSchema,
    status: typebox_1.Type.Optional(ruby_1.AppleChannelKeywordStatusSchema),
    bidAmount: typebox_1.Type.Optional(core_1.MoneySchema),
    forceBidAmount: (0, core_1.OptionalNullable)(core_1.MoneySchema),
    minBidAmount: typebox_1.Type.Optional(core_1.MoneySchema),
    maxBidAmount: typebox_1.Type.Optional(core_1.MoneySchema),
    apple: typebox_1.Type.Optional((0, core_1.StrictObject)({
        adGroupRef: ruby_1.AppleProxyRefSchema,
        keywordRef: ruby_1.AppleProxyRefSchema,
    })),
});
exports.GetRegionalKeywordAssignmentSchema = exports.RegionalKeywordAssignmentSchema;
exports.UpdateRegionalKeywordAssignmentBodySchema = (0, core_1.StrictObject)({
    assignments: typebox_1.Type.Array(exports.RegionalKeywordAssignmentSchema),
});
exports.RegionalKeywordAssignmentQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    country: typebox_1.Type.Optional(core_1.CountrySchema),
    purpose: typebox_1.Type.Optional(ruby_1.PurposeSchema),
});
exports.GetRegionalKeywordAssignmentQuerySchema = exports.RegionalKeywordAssignmentQuerySchema;
exports.ListRegionalKeywordAssignmentsResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.RegionalKeywordAssignmentSchema);
exports.UpdateRegionalKeywordAssignmentsResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.RegionalKeywordAssignmentSchema);
/**
 * Targeting Keyword API Types
 */
exports.CreateAppleTargetingKeywordBodySchema = (0, core_1.StrictObject)({
    match: ruby_1.KeywordMatchTypeSchema,
    text: ruby_1.KeywordSchema,
    tag: typebox_1.Type.Optional(ruby_1.TagSchema),
    status: ruby_1.AppleChannelKeywordStatusSchema,
});
exports.UpdateAppleTargetingKeywordBodySchema = (0, core_1.StrictObject)({
    tag: typebox_1.Type.Optional(ruby_1.TagSchema),
    status: ruby_1.AppleChannelKeywordStatusSchema,
});
exports.AppleTargetingKeywordResponseSchema = (0, core_1.StrictObject)({
    ...core_1.ModelMetaFields,
    match: ruby_1.KeywordMatchTypeSchema,
    text: ruby_1.KeywordSchema,
    tag: typebox_1.Type.Optional(ruby_1.TagSchema),
    status: ruby_1.AppleChannelKeywordStatusSchema,
    assignments: typebox_1.Type.Optional(typebox_1.Type.Array(exports.RegionalKeywordAssignmentSchema)),
});
exports.GetAppleTargetingKeywordQuerySchema = typebox_1.Type.Object({
    assignments: typebox_1.Type.Optional(typebox_1.Type.Boolean({ default: false })),
});
exports.GetAppleTargetingKeywordResponseSchema = exports.AppleTargetingKeywordResponseSchema;
exports.CreateAppleTargetingKeywordResponseSchema = exports.AppleTargetingKeywordResponseSchema;
exports.UpdateAppleTargetingKeywordResponseSchema = exports.AppleTargetingKeywordResponseSchema;
exports.ListAppleTargetingKeywordQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    assignments: typebox_1.Type.Optional(typebox_1.Type.Boolean({ default: false })),
});
exports.ListAppleTargetingKeywordResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AppleTargetingKeywordResponseSchema);
exports.ListAsrAppleCampaignNamesResponseSchema = (0, core_1.createUnsortedListResponseSchema)(common_1.AppleCampaignNameSchema);
exports.ListAsrAppleCampaignNamesQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({});
exports.UpdateAsrAppleCampaignNamesBodySchema = (0, core_1.StrictObject)({
    campaignNames: typebox_1.Type.Array(common_1.UpdateAppleCampaignNameSchema),
});
exports.UpdateAsrAppleCampaignNamesResponseSchema = (0, core_1.createUnsortedListResponseSchema)(common_1.AppleCampaignNameSchema);
exports.AsrTargetingKeywordHistoryResponseSchema = (0, core_1.createUnsortedListResponseSchema)((0, core_1.StrictObject)({
    country: core_1.CountrySchema,
    purpose: typebox_1.Type.Optional(ruby_1.PurposeSchema),
    period: core_1.TimestampSchema,
    bidAmount: typebox_1.Type.Optional(core_1.MoneySchema),
    status: (0, core_1.OptionalNullable)(apple_proxy_web_1.AppleProxyKeywordStatusSchema),
    keywordRef: core_1.IdSchema,
}));
exports.AsrTargetingKeywordHistoryQuerySchema = (0, core_1.StrictObject)({
    from: typebox_1.Type.Optional(core_1.TimestampSchema),
    to: typebox_1.Type.Optional(core_1.TimestampSchema),
});
